
(function () {
  'use strict';
  angular.module('vcfinance.unicat')
    .component('unicateditor', {
      restrict: 'E',
      bindings: {
        entry: '='
      },
      templateUrl: 'vcfinance/unicat/unicateditor-component.tpl.html',

      controllerAs: 'vm',
      controller: ['$log', 'Unicat', 'Rlog',
        function ($log, Unicat, Rlog) {
          let vm = this;
          vm.save = save;
          // vm.oncancel = oncancel;

          vm.$onInit = function () {


          };


          // save directly inside editor, unicat editing is fringe sscenario for experienced users
          function save(cat) {
            if (cat.$hasPendingActions()) {
              cat.$cancel();
              cat.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of unicat failed: ', err);
                Rlog.error('vcutils.unicat', 'unicateditor', 'Saving of unicat failed: ', {unicatid: cat._id});
              });
            }
            else {
              cat.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of unicat failed: ', err);
                Rlog.error('vcutils.unicat', 'unicateditor', 'Saving of unicat failed: ', {unicatid: cat._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());